<template>
  <div class="home">
    <div class="banner">
      <a-carousel v-if="bannerList && bannerList.length" :autoplay="true">
        <img
          v-for="item in bannerList"
          :key="item.adNo"
          :src="item.adPicUrl"
          @click="goPath(item.linkAddress)"
          class="banner-img"
        />
      </a-carousel>
    </div>
    <div class="sy_blocks gray">
      <div class="sy_btitle">数智化赋能传统零售门店及企业客户转型升级</div>
      <div class="sy_bsubtitle">
        提供全场景、全方位、全流程的数智化综合服务解决方案
      </div>
      <div class="menu_content">
        <div class="menu_box">
          <div class="box_left">
            <p class="box_title">千橙零售云</p>
            <p class="box_title_text">零售门店数智化升级，助力经营增收提效</p>
            <div class="btn_content">
              <div class="menu_item" @click="linkTo('QcErpSystem')">
                <div class="item_left">
                  <img src="@/assets/images/home/2023/icon-cf1.png" alt="" />
                </div>
                <div class="item_right">
                  <p class="btn_title">千橙ERP系统</p>
                  <p class="btn_text">到店/到家交易业务管理</p>
                </div>
              </div>
              <div class="menu_item" @click="linkTo('QcCashier')">
                <div class="item_left">
                  <img src="@/assets/images/home/2023/icon-cf2.png" alt="" />
                </div>
                <div class="item_right">
                  <p class="btn_title">千橙收银系统</p>
                  <p class="btn_text">半自动/自助一体机收单</p>
                </div>
              </div>
              <div class="menu_item" @click="linkTo('QcChain')">
                <div class="item_left">
                  <img src="@/assets/images/home/2023/icon-cf3.png" alt="" />
                </div>
                <div class="item_right">
                  <p class="btn_title">千橙连锁系统</p>
                  <p class="btn_text">支持直营/联营/加盟多业态</p>
                </div>
              </div>
              <div class="menu_item" @click="linkTo('QcShopkeeper')">
                <div class="item_left">
                  <img src="@/assets/images/home/2023/icon-cf4.png" alt="" />
                </div>
                <div class="item_right">
                  <p class="btn_title">千橙新零售系统</p>
                  <p class="btn_text">门店O2O一体化综合管理</p>
                </div>
              </div>
              <div class="menu_item" @click="linkTo('QcAssociation')">
                <div class="item_left">
                  <img src="@/assets/images/home/2023/icon-cf5.png" alt="" />
                </div>
                <div class="item_right">
                  <p class="btn_title">汇团团社群营销系统</p>
                  <p class="btn_text">社群团购分享小程序系统</p>
                </div>
              </div>
              <div class="menu_item" @click="linkTo('QcShoppingMall')">
                <div class="item_left">
                  <img src="@/assets/images/home/2023/icon-cf6.png" alt="" />
                </div>
                <div class="item_right">
                  <p class="btn_title">千橙微商城系统</p>
                  <p class="btn_text">社群电商小程序系统</p>
                </div>
              </div>
              <div class="menu_item" @click="linkTo('QcMarketing')">
                <div class="item_left">
                  <img src="@/assets/images/home/2023/icon-cf7.png" alt="" />
                </div>
                <div class="item_right">
                  <p class="btn_title">千橙会员营销系统</p>
                  <p class="btn_text">基于会员的SCRM系统</p>
                </div>
              </div>
            </div>
          </div>
          <div class="box_right">
            <div class="right_item">
              <p class="box_title">千橙电商云</p>
              <p class="box_title_text">
                全链路电商能力覆盖，支持多种电商模式落地
              </p>
              <div class="btn_content">
                <div class="menu_item" @click="linkTo('QcCommerce')">
                  <div class="item_left">
                    <img src="@/assets/images/home/2023/icon-cf8.png" alt="" />
                  </div>
                  <div class="item_right">
                    <p class="btn_title">千橙电商S2B2C系统</p>
                    <p class="btn_text">全链路全闭环交易系统</p>
                  </div>
                </div>
                <div class="menu_item" @click="linkTo('QcB2BChannel')">
                  <div class="item_left">
                    <img src="@/assets/images/home/2023/icon-cf9.png" alt="" />
                  </div>
                  <div class="item_right">
                    <p class="btn_title">千橙电商B2b分销系统</p>
                    <p class="btn_text">批发渠道多层级分销系统</p>
                  </div>
                </div>
                <div class="menu_item" @click="linkTo('QcLiveBroadcast')">
                  <div class="item_left">
                    <img src="@/assets/images/home/2023/icon-cf10.png" alt="" />
                  </div>
                  <div class="item_right">
                    <p class="btn_title">汇好看直播系统</p>
                    <p class="btn_text">视频号+小程序直播系统</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="right_item">
              <p class="box_title">千橙服务云</p>
              <p class="box_title_text">
                AI+新场景，提升运营服务效率
              </p>
              <div class="btn_content">
                <div class="menu_item" @click="linkTo('QcTool')">
                  <div class="item_left">
                    <img src="@/assets/images/home/2023/icon-cf11.png" alt="" />
                  </div>
                  <div class="item_right">
                    <p class="btn_title">千橙RPA工具箱</p>
                    <p class="btn_text">机器人流程自动化服务</p>
                  </div>
                </div>
                <div class="menu_item" @click="linkTo('QcDigit')">
                  <div class="item_left">
                    <img src="@/assets/images/home/2023/icon-cf12.png" alt="" />
                  </div>
                  <div class="item_right">
                    <p class="btn_title">千橙数字人</p>
                    <p class="btn_text">AI数字人直播助手</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="right_item">
              <p class="box_title">千橙分销云</p>
              <p class="box_title_text">
                打造“连接” +“提效”+“交易”的一站式智能分销平台
              </p>
              <div class="btn_content">
                <div class="menu_item" @click="linkTo('QcDistribution')">
                  <div class="item_left">
                    <img src="@/assets/images/home/2023/icon-cf13.png" alt="" />
                  </div>
                  <div class="item_right">
                    <p class="btn_title">千橙分销</p>
                    <p class="btn_text">基于企微的业务员分销系统</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sy_blocks">
      <div class="sy_btitle">专注八大行业 聚焦四大业务领域</div>
      <div class="sy_bsubtitle">辅以两大基础服务能力 两端闭环服务</div>
      <div class="sy_bimg">
        <img src="../../assets/images/home/2023/home3.png" />
      </div>
    </div>
    <div class="sy_blocks2">
      <div class="sy_btitle">强大的技术研发团队 保障系统安全稳定</div>
      <div class="sy_bsubtitle">
        技术创新有保障 200+项软件著作权及专利 持续升级
      </div>
      <div class="sy_bkinner">
        <div class="sy_bklis">
          <div class="sy_bkl_a">99.99<span>%</span></div>
          <div class="sy_bkl_b"></div>
          <div class="sy_bkl_c">系统更安全更稳定</div>
        </div>
        <div class="sy_bklis">
          <div class="sy_bkl_a">3000<span>笔</span></div>
          <div class="sy_bkl_b"></div>
          <div class="sy_bkl_c">动态扩容后秒级订单数</div>
        </div>
        <div class="sy_bklis">
          <div class="sy_bkl_a">300<span>毫秒</span></div>
          <div class="sy_bkl_b"></div>
          <div class="sy_bkl_c">毫秒级监控服务多维度能力告警</div>
        </div>
        <div class="sy_bklis">
          <div class="sy_bkl_a">98<span>%</span></div>
          <div class="sy_bkl_b"></div>
          <div class="sy_bkl_c">客户满意度高达</div>
        </div>
        <div class="sy_bklis">
          <div class="sy_bkl_a">200+<span>人</span></div>
          <div class="sy_bkl_b"></div>
          <div class="sy_bkl_c">技术团队保驾护航</div>
        </div>
      </div>
    </div>
    <div class="sy_blocks gray">
      <div class="sy_btitle">汇通数科SaaS全国服务网络系统</div>
      <div class="sy_bimg">
        <img src="../../assets/images/home/2023/home4.png" />
      </div>
    </div>
    <div class="sy_blocks" style="background-color: #FFFFFF;">
      <div class="sy_btitle">权威认证 实力认可</div>
      <div class="sy_bkinner">
        <div class="sy_bklis">
          <div class="sy_bkimg">
            <img src="../../assets/images/home/2023/home5.png" />
          </div>
          <div class="sy_bktxt">双软认证</div>
        </div>
        <div class="sy_bklis">
          <div class="sy_bkimg">
            <img src="../../assets/images/home/2023/home6.png" />
          </div>
          <div class="sy_bktxt">高新技术企业</div>
        </div>
        <div class="sy_bklis">
          <div class="sy_bkimg">
            <img src="../../assets/images/home/2023/home7.png" />
          </div>
          <div class="sy_bktxt">企业信用等级证书（AAA）</div>
        </div>
        <div class="sy_bklis">
          <div class="sy_bkimg">
            <img src="../../assets/images/home/2023/home8.png" />
          </div>
          <div class="sy_bktxt">网络安全等级保护2.0（三级）</div>
        </div>
        <div class="sy_bklis">
          <div class="sy_bkimg">
            <img src="../../assets/images/home/2023/home9.png" />
          </div>
          <div class="sy_bktxt">质量管理体系认证</div>
        </div>
      </div>
    </div>
    <div class="sy_blocks gray">
      <div class="sy_btitle">企业动态</div>
      <div class="sy_bkinner overshow">
        <div
          class="sy_bilis"
          v-for="item in newsList"
          :key="item.infoNo"
          @click="jumpDetail(item.infoNo)"
        >
          <div class="sy_bil_img">
            <img :src="item.coverUrl" />
          </div>
          <div class="sy_bil_title">{{ item.title }}</div>
          <div class="sy_bil_desc">
            <p v-html="item.content"></p>
          </div>
        </div>
        <!-- <div class="sy_bilis ">
                    <div class="sy_bil_img">
                        <img src="../../assets/images/home/2023/home1.png" />
                    </div>
                    <div class="sy_bil_title">汇通达会员店增长背后：以服务创价值，门店</div>
                    <div class="sy_bil_desc">老店经营者可能更关注进货渠道，希望汇通达老店经营者可能更关注进货渠道，希望汇通达</div>
                </div>
                <div class="sy_bilis ">
                    <div class="sy_bil_img">
                        <img src="../../assets/images/home/2023/home1.png" />
                    </div>
                    <div class="sy_bil_title">汇通达会员店增长背后：以服务创价值，门店</div>
                    <div class="sy_bil_desc">老店经营者可能更关注进货渠道，希望汇通达</div>
                </div> -->
      </div>
      <div class="sy_bkbtn" @click="viewMoreNews">更多新闻</div>
    </div>
    <Contact :isIndex="true"></Contact>
  </div>
</template>
<script>
import Contact from "@/components/Contact";
import metaInfo from "@/common/util/metaInfo";
import {
  getAdvertiseList,
  simpleInformationCollection,
  browseCount,
  getOfficialWebsiteInfomationList,
} from "@/apis/index";

export default {
  name: "Index",
  metaInfo: metaInfo.Index,
  components: {
    Contact,
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: "connact" }),
      bannerList: [],
      captchaIns: null,
      params: null,
      newsList: [],
    };
  },
  mounted() {
    this.getBannerList();
    this.getCode();
    this.getDynamicList();
  },
  methods: {
    goPath(item){
        console.log(item,'itemitem')
        if (item) {
        window.open(item);
      }
    },
    jumpDetail(id) {
      this.$router.push({ path: "/dynamicDetail/" + id });
    },
    getDynamicList() {
      const params = {
        pageNum: 1,
        pageSize: 3,
      };
      getOfficialWebsiteInfomationList(params)
        .then((res) => {
          const { rows } = res;
          rows.forEach((item) => {
            item.content = item.content.replace(/<[^<>]+>/g, "");
          });
          this.newsList = res.rows;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    //更多新闻点击
    viewMoreNews() {
      this.$router.push({
        path: "dynamic",
      });
    },
    linkTo(path) {
      if (!path.startsWith("/")) {
        path = "/" + path;
      }
      this.$router.push({ path });
      browseCount();
    },
    checktelphone(rule, value, callback) {
      const reg = /^1[3456789]\d{9}$/;
      if (value && !reg.test(value)) {
        callback("请输入正确的手机号码！");
      } else {
        callback();
      }
    },
    getBannerList() {
      // 1：订阅，2：工作台，3:首页，4:PC官网首页，5:h5官网首页
      var params = { releaseSystemLocation: 4 };
      getAdvertiseList(params)
        .then((res) => {
          this.bannerList = res;
          //this.bannerList = [{adPicUrl:''},{adPicUrl:''}]
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.captchaIns.popUp();
          this.params = {
            infoSources: "汇通数科官网-首页",
            officialWebsiteEntrance: "PC",
            name: values.name,
            phone: values.phone,
          };
        }
      });
    },
    getCode() {
      const that = this;
      // eslint-disable-next-line no-undef
      initNECaptcha &&
        initNECaptcha(
          {
            element: "#captcha",
            captchaId: "6c0483e901164a789d9d13f0291ba257",
            mode: "popup",
            width: "320px",
            // enableClose: true,
            onClose: function () {
              // 弹出关闭结束后将会触发该函数
            },
            onVerify: function (err, data) {
              if (err) return;
              // that.captchaIns.close()
              that.params.pictureCode = data.validate;
              simpleInformationCollection(that.params)
                .then((res) => {
                  that.$message.success({
                    content: "感谢您的信息提交，我们将会有专员与您联系~",
                    duration: 1,
                  });
                  that.captchaIns.refresh();
                  that.form.resetFields();
                })
                .catch((err) => {
                  that.$message.error(err);
                  that.captchaIns.refresh();
                });
            },
          },
          function (instance) {
            // 初始化成功后得到验证实例instance，可以调用实例的方法
            that.captchaIns = instance;
          },
          function (err) {
            console.log(err);
            // 初始化失败后触发该函数，err对象描述当前错误信息
          }
        );
    },
  },
};
</script>
<style lang="less" scoped>
.menu_content {
  margin-top: 40px;
  width: 1200px;
  height: 548px;
  .menu_box {
    width: 1200px;
    height: 548px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    .box_title {
      height: 33px;
      font-size: 24px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 33px;
      margin-bottom: 0px;
      text-align: left;
    }
    .box_title_text {
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 20px;
      margin-top: 4px;
      margin-bottom: 0px;
      text-align: left;
    }
    .box_left {
      width: 497px;
      height: 546px;
      background: url("~@/assets/images/home/2023/menuBanner1.png") no-repeat
        center;
      background-size: 100% 100%;
      padding: 20px;
      .btn_content {
        width: 100%;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: flex-start;
        margin-top: 18px;
        .menu_item {
          width: 192px;
          height: 56px;
          background: #ffffff;
          border-radius: 3px;
          display: flex;
          flex-direction: row;
          justify-content: center;
          padding: 11px 10px;
          margin-right: 30px;
          margin-bottom: 25px;
          cursor: pointer;
          .item_left {
            width: 20px;
            img {
              width: 20px;
              height: 20px;
            }
          }
          .item_right {
            flex: 1;
            padding-left: 5px;
            .btn_title {
              height: 20px;
              font-size: 14px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              color: #333333;
              line-height: 20px;
              margin-bottom: 0px;
              text-align: left;
            }
            .btn_text {
              height: 14px;
              font-size: 10px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              color: #999999;
              line-height: 14px;
              margin-bottom: 0px;
              text-align: left;
            }
          }
        }
      }
    }
    .box_right {
      width: 662px;
      height: 546px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .right_item {
        padding: 20px 0 0 20px;
        width: 662px;
        height: 172px;
        background: url("~@/assets/images/home/2023/menuBanner2.png") no-repeat
          center;
        background-size: 100% 100%;
        .btn_content {
          width: 100%;
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          margin-top: 18px;
          flex-wrap: wrap;
          .menu_item {
            width: 192px;
            height: 56px;
            background: #ffffff;
            border-radius: 3px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            padding: 11px 10px;
            margin-right: 16px;
            cursor: pointer;
            .item_left {
              width: 20px;
              img {
                width: 20px;
                height: 20px;
              }
            }
            .item_right {
              flex: 1;
              padding-left: 5px;
              .btn_title {
                height: 20px;
                font-size: 14px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                color: #333333;
                line-height: 20px;
                margin-bottom: 0px;
                text-align: left;
              }
              .btn_text {
                height: 14px;
                font-size: 10px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                color: #999999;
                line-height: 14px;
                margin-bottom: 0px;
                text-align: left;
              }
            }
          }
        }
      }
    }
  }
}

//2023-11-22王强新加
.sy_bkbtn {
  width: 170px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #ffffff;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  cursor: pointer;
  border: 1px solid #999999;
  margin: 0 auto;
  margin-top: 40px;
}
.sy_bkbtn:hover {
  box-shadow: 0px 0px 10px #ccc;
}
.sy_bilis {
  width: 375px;
  height: 380px;
  overflow: hidden;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 0px 10px #ccc;
  cursor: pointer;
}
.sy_bilis:hover {
  box-shadow: 0px 4px 14px #ccc;
}
.sy_bil_img {
  height: 195px;
  display: block;
}
.sy_bil_img img {
  width: 100%;
  height: 100%;
}
.sy_bil_img img:hover {
  transform: scale(1.05, 1.05);
  transition: all 0.3s linear;
}
.sy_bil_title {
  height: 56px;
  font-size: 20px;
  font-weight: 600;
  color: #333333;
  line-height: 28px;
  overflow: hidden;
  margin: 15px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-align: justify;
}
.sy_bil_title:hover {
  color: #40a9ff;
}
.sy_bil_desc {
  height: 60px;
  font-size: 14px;
  font-weight: 400;
  margin: 15px;
  color: #666666;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  text-align: justify;
  line-height: 20px;
}

.sy_bkimg {
  width: 180px;
  height: 156px;
  margin: 0 auto;
}
.sy_bkimg img {
  width: 100%;
  height: 100%;
}
.sy_bktxt {
  text-align: center;
  height: 22px;
  font-size: 16px;
  font-weight: 400;
  color: #595961;
  line-height: 22px;
}
.sy_bkinner {
  width: 1200px;
  overflow: hidden;
  margin: 0 auto;
  margin-top: 70px;
  display: flex;
  justify-content: space-between;
}
.sy_bkinner.overshow {
  overflow: visible;
}
.sy_bklis {
  width: auto;
  overflow: hidden;
  text-align: left;
  float: left;
}
.sy_bkl_a {
  height: 50px;
  font-size: 46px;
  font-weight: 400;
  color: #ffffff;
  line-height: 50px;
}
.sy_bkl_a span {
  font-size: 16px;
  margin-left: 5px;
}
.sy_bkl_b {
  width: 68px;
  height: 8px;
  margin-top: 10px;
  margin-bottom: 10px;
  background: #3986ff;
}
.sy_bkl_c {
  height: 22px;
  font-size: 16px;
  font-weight: 400;
  color: #bdbdbd;
  line-height: 22px;
}

.sy_blocks2 {
  height: 426px;
  overflow: hidden;
  background: url("../../assets/images/home/2023/home2.png") no-repeat center;
}
.sy_blocks2 .sy_btitle {
  color: #fff;
  margin-top: 60px;
}
.sy_blocks2 .sy_bsubtitle {
  color: #bdbdbd;
}
.sy_blocks {
  overflow: hidden;
  padding-top: 60px;
  padding-bottom: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #FFFFFF;
}
.sy_blocks.gray {
  background: linear-gradient(180deg, #fdfdfd 0%, #fafafa 100%);
}
.sy_btitle {
  height: auto;
  font-size: 36px;
  font-weight: 500;
  color: #333333;
  line-height: 40px;
  text-align: center;
}
.sy_bsubtitle {
  height: auto;
  font-size: 20px;
  font-weight: 500;
  color: #333333;
  line-height: 30px;
  text-align: center;
  margin-top: 15px;
}

.sy_bimg {
  width: 1200px;
  margin: 0 auto;
  margin-top: 25px;
}
//2023-11-22王强新加over
.banner-img {
  width: 100%;
  min-width: 1200px;
  height: 420px;
  object-fit: cover;
}

.block-01 {
  background: #fafafa;
  overflow: hidden;

  .block-01-content {
    padding: 56px 0 58px 0;
    width: 1200px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;

    .groupItem {
      width: 224px;
      height: 410px;

      .title {
        font-size: 18px;
        font-weight: 500;
        color: #ffffff;
        line-height: 68px;
      }

      .item {
        min-width: 56px;
        display: flex;
        flex-direction: column;
        margin-bottom: 15px;

        img {
          display: block;
          width: 40px;
          height: 40px;
          margin: 0 auto;
        }

        span {
          font-size: 14px;
          font-weight: 500;
          color: #595961;
          padding-top: 5px;
        }
      }

      .content {
        height: 342px;
        padding: 18px 42px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        background: #fff;

        .item-four {
          img {
            width: 38px;
            height: 30px;
          }

          span {
            padding-top: 15px;
          }
        }

        .item {
          cursor: pointer;
        }
      }

      .content-column {
        height: 342px;
        flex-direction: column;
        align-items: center;
        background: #fff;
        padding-top: 18px;

        .item {
          margin: 0 auto 15px;
          cursor: pointer;
        }
      }
    }

    .groupItem:nth-child(1) {
      background: url("~@/assets/images/home/home-pic-01.png") no-repeat;
    }

    .groupItem:nth-child(2) {
      background: url("~@/assets/images/home/home-pic-02.png") no-repeat;
    }

    .groupItem:nth-child(3) {
      background: url("~@/assets/images/home/home-pic-03.png") no-repeat;
    }

    .groupItem:nth-child(4) {
      background: url("~@/assets/images/home/home-pic-04.png") no-repeat;
    }

    .groupItem:nth-child(5) {
      background: url("~@/assets/images/home/home-pic-05.png") no-repeat;
    }
  }
}

.block-02 {
  background: #ffffff;
  overflow: hidden;

  .home-focus {
    width: 1124px;
  }
}

.block-03 {
  height: 426px;
  background: url("~@/assets/images/home/home-bg-01.png") no-repeat 0 0;

  .sk-block-title {
    .title {
      color: #ffffff;
    }

    .sub-title {
      color: #bdbdbd;
    }
  }

  .block-03-content {
    width: 1200px;
    margin: 60px auto 0 auto;
    display: flex;
    justify-content: space-between;
    color: #ffffff;

    & > div {
      text-align: left;
    }

    .number {
      font-size: 46px;
      font-weight: 600;
      line-height: 65px;
    }

    .unit {
      margin-left: 7px;
      font-size: 16px;
      font-weight: 400;
      line-height: 22px;
    }

    .line {
      margin-top: 11px;
      width: 68px;
      height: 8px;
      background: #3986ff;
    }

    .text {
      margin-top: 20px;
      font-size: 16px;
      font-weight: 400;
      color: #bdbdbd;
      line-height: 22px;
      text-align: left;
    }
  }
}

.block-04 {
  background: #fafafa;

  .block-04-content {
    width: 1200px;
    margin: 0 auto;
    text-align: left;
    padding-top: 14px;

    .left {
      display: inline-block;
      vertical-align: top;
    }

    .right {
      margin-left: 189px;
      display: inline-block;
      vertical-align: top;

      img {
        width: 692px;
      }
    }

    .cell {
      width: 163px;
      padding: 17px 0 28px 0;
    }

    .cell:not(:last-child) {
      border-bottom: 1px solid #dfe0e7;
    }

    .number {
      font-size: 48px;
      font-weight: bold;
      color: #3986ff;
      line-height: 56px;
    }

    .unit {
      font-size: 24px;
      font-weight: bold;
      color: #3986ff;
      line-height: 31px;
    }

    .text {
      margin-top: 6px;
      font-size: 16px;
      color: #595961;
      line-height: 21px;
    }

    .coo {
      text-align: center;

      & > div {
        font-size: 36px;
        font-weight: 500;
        color: #595961;
        line-height: 42px;
      }

      img {
        margin: 40px 0 50px 0;
      }
    }
  }
}

.block-05 {
  background-color: #ffffff;

  .block-05-content {
    width: 1100px;
    display: flex;
    margin: 0 auto;
    justify-content: space-between;
    text-align: center;
    padding-bottom: 72px;

    .name {
      width: 120px;
      font-size: 16px;
      font-weight: 400;
      color: #595961;
      line-height: 22px;
      margin: 0 auto;
    }
  }
}

.block-06 {
  height: 409px;
  background: url("~@/assets/images/home/home-bg-02.png") no-repeat 0 0;
  padding: 50px 0 55px 0;
  text-align: center;

  .title {
    font-size: 30px;
    font-weight: 500;
    color: #ffffff;
    line-height: 42px;
  }

  .content {
    width: 500px;
    margin: 40px auto 0 auto;

    /deep/ .ant-btn-primary {
      height: 58px;
      font-size: 23px;
    }
  }
}
</style>
